import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeDemo: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="theme-demo" style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>Theme Demo - Current Theme: {theme}</h1>
      
      <section style={{ marginTop: '32px' }}>
        <h2>Cards</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px', marginTop: '16px' }}>
          <div className="glass-card">
            <h3>Glass Card</h3>
            <p>This is a glass card with the current theme applied. Notice how the styling adapts to each theme.</p>
            <button style={{ marginTop: '8px' }}>Action Button</button>
          </div>
          
          <div className="emp-glass-card" style={{ padding: '16px' }}>
            <h3>EmpowerID Identity Fabric Card</h3>
            <p>This card uses the emp-glass-card class for compatibility with the EmpowerID Identity Fabric UI library.</p>
            <a href="#">Link example</a>
          </div>
        </div>
      </section>

      <section style={{ marginTop: '32px' }}>
        <h2>Form Elements</h2>
        <div className="glass-card" style={{ marginTop: '16px' }}>
          <form onSubmit={(e) => e.preventDefault()}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', color: 'var(--main-text-secondary)' }}>
                Text Input
              </label>
              <input type="text" placeholder="Enter some text..." style={{ width: '100%' }} />
            </div>
            
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', color: 'var(--main-text-secondary)' }}>
                Textarea
              </label>
              <textarea placeholder="Enter a longer message..." rows={4} style={{ width: '100%' }} />
            </div>
            
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', color: 'var(--main-text-secondary)' }}>
                Select Dropdown
              </label>
              <select style={{ width: '100%' }}>
                <option>Option 1</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            
            <div style={{ display: 'flex', gap: '8px' }}>
              <button type="submit">Submit</button>
              <button type="button" style={{ 
                background: 'transparent', 
                color: 'var(--main-text)', 
                border: '1px solid var(--border-color)' 
              }}>
                Cancel
              </button>
              <button type="button" disabled>Disabled</button>
            </div>
          </form>
        </div>
      </section>

      <section style={{ marginTop: '32px' }}>
        <h2>Typography & Colors</h2>
        <div className="glass-card" style={{ marginTop: '16px' }}>
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <h4>Heading 4</h4>
          <p style={{ color: 'var(--main-text)' }}>Primary text color</p>
          <p style={{ color: 'var(--main-text-secondary)' }}>Secondary text color</p>
          <p>
            This is a paragraph with a <a href="#">link</a> and some <strong>bold text</strong> and <em>italic text</em>.
          </p>
          
          <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <div style={{ 
              padding: '8px 16px', 
              background: 'var(--main-accent)', 
              color: 'var(--button-text)', 
              borderRadius: '4px' 
            }}>
              Accent Color
            </div>
            <div style={{ 
              padding: '8px 16px', 
              background: 'var(--main-bg-elevated)', 
              color: 'var(--main-text)', 
              borderRadius: '4px',
              border: '1px solid var(--border-color)'
            }}>
              Elevated Background
            </div>
            <div style={{ 
              padding: '8px 16px', 
              background: 'var(--card-bg)', 
              color: 'var(--main-text)', 
              borderRadius: '4px',
              border: '1px solid var(--card-border)'
            }}>
              Card Background
            </div>
          </div>
        </div>
      </section>

      <section style={{ marginTop: '32px' }}>
        <h2>Table</h2>
        <div style={{ marginTop: '16px', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Role</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '12px' }}>John Doe</td>
                <td style={{ padding: '12px' }}>Administrator</td>
                <td style={{ padding: '12px' }}>
                  <span style={{ 
                    padding: '4px 8px', 
                    background: 'var(--ion-lime)', 
                    color: 'var(--void-black)', 
                    borderRadius: '4px',
                    fontSize: '12px' 
                  }}>
                    Active
                  </span>
                </td>
                <td style={{ padding: '12px' }}>
                  <a href="#" style={{ marginRight: '8px' }}>Edit</a>
                  <a href="#">Delete</a>
                </td>
              </tr>
              <tr>
                <td style={{ padding: '12px' }}>Jane Smith</td>
                <td style={{ padding: '12px' }}>User</td>
                <td style={{ padding: '12px' }}>
                  <span style={{ 
                    padding: '4px 8px', 
                    background: 'var(--signal-amber)', 
                    color: 'var(--void-black)', 
                    borderRadius: '4px',
                    fontSize: '12px' 
                  }}>
                    Pending
                  </span>
                </td>
                <td style={{ padding: '12px' }}>
                  <a href="#" style={{ marginRight: '8px' }}>Edit</a>
                  <a href="#">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default ThemeDemo;
